import {
  AWXConnectedAccountStatus,
  type AwxConnectedAccount,
  AwxConnectedAccountType,
} from '@ankor-io/common/types/awx'

/**
 * Maps connected accounts from the organization vessels list (GET /api/pay/org/:orgId/vessel)
 * to AwxConnectedAccount shape. Single source of truth: no separate per-vessel connected-accounts call.
 */
export function mapVesselListConnectedAccountsToAwx(
  vesselId: string,
  organizationId: string,
  listConnectedAccounts: { id: string; name: string; status: string; type: string }[],
): AwxConnectedAccount[] {
  return listConnectedAccounts.map((acct) => ({
    id: acct.id,
    name: acct.name,
    status: acct.status as AWXConnectedAccountStatus,
    organization_id: organizationId,
    type: acct.type as AwxConnectedAccountType,
    vesselId,
  }))
}
